const LOCK_COUNT_KEY = '__hammerScrollLockCount';

type WindowWithScrollLock = Window & {
  [LOCK_COUNT_KEY]?: number;
};

const getLockWindow = (): WindowWithScrollLock | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return window as WindowWithScrollLock;
};

export const acquireScrollLock = (): void => {
  if (typeof document === 'undefined') return;

  const lockWindow = getLockWindow();
  const nextLockCount = (lockWindow?.[LOCK_COUNT_KEY] ?? 0) + 1;

  if (lockWindow) {
    lockWindow[LOCK_COUNT_KEY] = nextLockCount;
  }

  if (nextLockCount === 1) {
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('scroll-locked');
  }
};

export const releaseScrollLock = (): void => {
  if (typeof document === 'undefined') return;

  const lockWindow = getLockWindow();
  const nextLockCount = Math.max(0, (lockWindow?.[LOCK_COUNT_KEY] ?? 0) - 1);

  if (lockWindow) {
    lockWindow[LOCK_COUNT_KEY] = nextLockCount;
  }

  if (nextLockCount === 0) {
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('scroll-locked');
  }
};
